import axios from '../localAxios';
import { verifyEmailURL } from './url';

interface SubmitVerificationCodeParams {
  code: string;
}

export async function verifyEmail({ code }: SubmitVerificationCodeParams) {
  const url = verifyEmailURL();
  return axios.post<{ message: string }>(url.toString(), { code });
}
